/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmptyResponse } from '../../models/empty-response';
import { EsgTicketDelete } from '../../models/esg-ticket-delete';

export interface EsgTicketBatchDeleteForEsg$Params {
  profileId: number;
  year: number;
  code: string;
      body?: Array<EsgTicketDelete>
}

export function esgTicketBatchDeleteForEsg(http: HttpClient, rootUrl: string, params: EsgTicketBatchDeleteForEsg$Params, context?: HttpContext): Observable<StrictHttpResponse<EmptyResponse>> {
  const rb = new RequestBuilder(rootUrl, esgTicketBatchDeleteForEsg.PATH, 'delete');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmptyResponse>;
    })
  );
}

esgTicketBatchDeleteForEsg.PATH = '/esg/profile/{profileId}/esg/{year}/{code}/ticket';
